import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { JaiJuiSenderSelect as SENDER_SELECT } from 'Components/Api/SenderAPI';

import { Select as BANK_SELECT } from 'Components/Api/DMTBankAPI';
import { CompositeBeneAdd as BENE_ADD } from 'Components/Api/BeneficiaryAPI';
import { JaiJuiDMTMoneyTransfer as DMT_TRANSFER } from 'Components/Api/DMTTransferApi';
import { Select as BENE_SELECT } from 'Components/Api/BeneficiaryAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import ReactTable from 'Components/ReactTable/ReactTable';

import {
    Container,
    Grid,
    Paper,
    Button,
    Box,
    CircularProgress,
    Hidden
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import HOCLoader from 'Components/Loader/HOCLoader';
import { KeyValueModal } from 'Components/Modal/KeyValueModal';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryAdd = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isReadOnly, setReadOnly] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const [isBeneVerifyOpen, setIsBeneVerifyOpen] = useState(false);

    const [BeneVerifyDetails, setBeneVerifyDetails] = useState([]);

    const [verifyStatus, setVerifyStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [severity, setSeverity] = useState('success');
    const Mobile = location?.state?.Mobile;
    const SenderID = location?.state?.SenderID;
    const [isAddOnly, setIsAddOnly] = useState(false);

    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }

    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: ''
    });
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        SenderID: SenderID,
        Name: '',
        Bank: bankDefault,
        DefaultIFSC: '',
        AccountNo: '',
        ConfirmAccountNo: '',
        IFSC: '',
        isAddOnly: false,
        IsNameVerified: false
    });
    const reset = () => {
        setBankDefault({
            Name: 'Select Bank',
            DefaultIFSC: ''
        });
        setFormObject({
            Mobile: Mobile,
            SenderID: SenderID,
            Name: '',
            Bank: bankDefault,
            AccountNo: '',
            ConfirmAccountNo: '',
            IFSC: '',
            isAddOnly: false,
            IsNameVerified: false
        });
    };
    useEffect(() => {
        selectBank();
        selectBene();
        createColumns();
        fetchConsumerNumberFontSize();
    }, []);

    const selectBene = async () => {
        if (SenderID === undefined) return;

        if (SenderID === '') return;

        var beneReqObj = JSON.stringify({
            SenderID: SenderID
        });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setList(data);
    };

    const selectBank = async () => {
        const response = await BANK_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const submithandle = async (
        values,
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        setResponseMessage('');

        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            return;
        }

        let jsonObj = {
            Mobile: values.Mobile,
            Name: values.Name,
            BankName: values.Bank.Name,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            BeneficiaryID: values.Mobile,
            SenderID: values.Mobile,
            Amount: 1,
            PaymentType: 'IMPS',
            RechargePin: '',
            Through: 'WEB',
            IsVerify: true
        };

        setIsError(false);
        //setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        setVerifyStatus(data.Status);

        if (data.Status === 'SUCCESS') {
            setReadOnly(true);
            setFieldValue('IsNameVerified', true);
        }
        createKeyValuePair(data);
        setIsBeneVerifyOpen(true);
        setFieldValue('Name', data.BeneficiaryName);
    };

    const createKeyValuePair = (data) => {
        if (data.Status === 'FAILURE') {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber),
                VerifyData('Message', data.Description)
            ];
            setBeneVerifyDetails(rows);
        } else {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber)
            ];
            setBeneVerifyDetails(rows);
        }
    };

    function VerifyData(Key, Value) {
        return { Key, Value };
    }

    const core_bene_add = async (values, beneName) => {
        setResponseMessage('');
        var request = {
            Name: beneName,
            BankName: values.Bank.Name,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            SenderID: values.SenderID,
            SenderMobile: values.Mobile,
            IsNameVerified: values.IsNameVerified
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);

        if (!response.isAuthorized) LOGOUT();
        setLoading(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setSeverity('success');

        var param = {
            BeneficiaryID: data.BeneficiaryID,
            Mobile: values.Mobile
        };
        if (
            data.Message === 'OTP sent on sender number' ||
            data.Message === 'Please verify beneficiary OTP'
        ) {
            history.push('/JJ_BeneVerify', param);
            return;
        } else {
            let param1 = {
                Mobile: values.Mobile
            };

            history.push('/JJ_SenderSearch', param1);
            return;
        }
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        setMainColumns(columns);
    };

    const FormValidationSchema = Yup.object({
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')

            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),

        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        isAddOnly: Yup.boolean(),

        Name: Yup.string().when(['isAddOnly'], {
            is: (isAddOnly) => isAddOnly,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
        }),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        ConfirmAccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'confirm account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no')
            .oneOf([Yup.ref('AccountNo'), null], "AccountNo don't match"),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Beneficiary Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'IFSC',
                                                                value.DefaultIFSC
                                                            );
                                                            setBankDefault({
                                                                Name:
                                                                    value.Name,
                                                                DefaultIFSC:
                                                                    value.DefaultIFSC
                                                            });
                                                        }}
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Name}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.Name ===
                                                            value.Name
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="IFSC"
                                                        name="IFSC"
                                                        type="text"
                                                        length={11}
                                                        placeholder="IFSC"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Account No."
                                                        name="AccountNo"
                                                        autoComplete="new-password"
                                                        type="text"
                                                        length={20}
                                                        placeholder="Account No."
                                                        typed_length={1}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={9}
                                                    lg={9}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Confirm Account No."
                                                        name="ConfirmAccountNo"
                                                        type="text"
                                                        length={20}
                                                        placeholder="Confirm Account No."
                                                        typed_length={1}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <div
                                                        className={
                                                            classes.SubmitWrapper
                                                        }
                                                    >
                                                        <Button
                                                            type="submit"
                                                            title="Verify"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            onClick={(e) => {
                                                                setFieldValue(
                                                                    'isAddOnly',
                                                                    false
                                                                );
                                                                handleSubmit(e);
                                                            }}
                                                            disabled={loading}
                                                        >
                                                            Verify
                                                        </Button>
                                                        {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Bene Name"
                                                        name="Name"
                                                        type="text"
                                                        placeholder="Bene Name"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="text"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />

                                                    <Hidden xsUp>
                                                        <MaterialTextField
                                                            label="IsNameVerified"
                                                            name="IsNameVerified"
                                                            type="text"
                                                            placeholder="IsNameVerified"
                                                        />
                                                    </Hidden>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={() => {
                                                    reset();
                                                }}
                                            >
                                                Reset
                                            </Button>

                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={(e) => {
                                                    var param = {
                                                        Mobile: values.Mobile
                                                    };

                                                    history.push(
                                                        '/JJ_SenderSearch',
                                                        param
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Beneficiary List
                                </h2>
                                <ReactTable data={list} columns={mainColumns} />
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isBeneVerifyOpen ? (
                <KeyValueModal
                    isOpen={isBeneVerifyOpen}
                    request={BeneVerifyDetails}
                    title="VERIFY"
                    status={verifyStatus}
                    OKButtonClick={() => {
                        setIsBeneVerifyOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
